import React, { useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import {
  getClassifiersDisseminationLevelChange,
  getClassifiersDisseminationLevelItem,
  getClassifiersDisseminationLevelItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { disseminationLevel } from '../../constants/parameters';
import validateSchema from './validateSchema';
import { FORM_DISSEMINATION_LEVEL_EDIT } from '../../constants/formKeys';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

const DisseminationLevelEdit = ({
  t,
  fetchClassifierDisseminationLevel,
  changeClassifierDisseminationLevel,
  fetchClassifierDisseminationLevelList,
  isLoading,
  operatorCode,
  onCancel,
  onComplete,
  initialValues: initialValuesProp,
}) => {
  useEffect(() => {
    if (operatorCode) {
      fetchClassifierDisseminationLevel(operatorCode);
    }
  }, [operatorCode, fetchClassifierDisseminationLevel]);

  // Convert Immutable Map to plain JS
  const initialValues = initialValuesProp?.toJS
    ? initialValuesProp.toJS()
    : initialValuesProp || {
        [disseminationLevel.CODE]: '',
        [disseminationLevel.LANG]: {
          [disseminationLevel.ENGLISH]: '',
          [disseminationLevel.ESTONIAN]: '',
        },
      };

  const validate = makeRffValidateFromLegacy(
    validateSchema,
    { t },
    initialValues
  );

  const onSubmit = async (values) => {
    const result = await changeClassifierDisseminationLevel(values);

    if (!result.error) {
      notification.info({
        message: t('completeTitle'),
        description: t('completeBody'),
      });

      onComplete();
    }

    await fetchClassifierDisseminationLevelList();
    await classifiersStore.update();
  };

  return (
    <Spin spinning={isLoading}>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FormStateToRedux form={FORM_DISSEMINATION_LEVEL_EDIT} />
            <Row gutter={32}>
              <Col span={24}>
                <Field
                  name={disseminationLevel.CODE}
                  label={t('fieldCode')}
                  component={TextField}
                  disabled={!!operatorCode}
                  required
                />
              </Col>
            </Row>
            <Row gutter={32}>
              <Col span={12}>
                <Field
                  name={`${disseminationLevel.LANG}.${disseminationLevel.ENGLISH}`}
                  label={t('fieldEn')}
                  component={TextField}
                  required
                />
              </Col>
              <Col span={12}>
                <Field
                  name={`${disseminationLevel.LANG}.${disseminationLevel.ESTONIAN}`}
                  label={t('fieldEt')}
                  component={TextField}
                  required
                />
              </Col>
            </Row>
            <FormActions>
              <Button onClick={onCancel}>{t('buttonCancel')}</Button>
              <Button htmlType="submit" type="primary">
                {t('buttonSave')}
              </Button>
            </FormActions>
          </form>
        )}
      />
    </Spin>
  );
};

DisseminationLevelEdit.propTypes = {
  t: PropTypes.func.isRequired,
  fetchClassifierDisseminationLevel: PropTypes.func.isRequired,
  changeClassifierDisseminationLevel: PropTypes.func.isRequired,
  fetchClassifierDisseminationLevelList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  operatorCode: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

const getIsLoading = getLoadingSelector(
  getClassifiersDisseminationLevelChange,
  getClassifiersDisseminationLevelItem
);

const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.operatorCode
    ? getClassifiersDisseminationLevelItemData(state)
    : null,
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  fetchClassifierDisseminationLevel: actions.fetchClassifierDisseminationLevel,
  changeClassifierDisseminationLevel:
    actions.changeClassifierDisseminationLevel,
  fetchClassifierDisseminationLevelList:
    actions.fetchClassifierDisseminationLevelList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisseminationLevelEdit);
